module.exports = __webpack_public_path__ + "static/img/mail-a01.175e82b0.png";